import { render } from "./Materials.vue?vue&type=template&id=29b87a8a&ts=true"
import script from "./Materials.vue?vue&type=script&lang=ts"
export * from "./Materials.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__